import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import SideBarContainer from 'Containers/SideBarContainer';
import useTranslation from 'Hooks/useTranslation';
import { checkPermission } from 'Utils/permissions';
import { usePermissionStore } from 'stores/permissions-store';
import { PageHeader, SectionGrid, SectionCard } from 'Components/ui';
import { settingsSections } from './data/sections';

const PageBody = styled.div({
  flex: 1,
  padding: '34px 40px 64px',
});

/**
 * Hub de Configuración. Pinta el encabezado y la rejilla de secciones a partir
 * de `settingsSections`; cada tarjeta navega a su ruta cuando está disponible.
 */
export default function Settings() {
  const history = useHistory();
  const { t2 } = useTranslation('Settings');

  // Cada sección declara su `requiredPermission` (si aplica). Mostramos solo las
  // que el usuario puede ver; las que no piden permiso se muestran siempre.
  const permissions = usePermissionStore(state => state.permissions);
  const sections = settingsSections.filter(
    section => !section.requiredPermission || checkPermission(permissions, section.requiredPermission)
  );

  return (
    <SideBarContainer navBar={false}>
      <PageBody>
        <PageHeader title={t2('title')} description={t2('subtitle')} />
        <SectionGrid>
          {sections.map(section => (
            <SectionCard
              key={section.id}
              icon={section.icon}
              iconBg={section.iconBg}
              iconColor={section.iconColor}
              title={t2(section.titleKey)}
              description={t2(section.descriptionKey)}
              ctaLabel={t2(section.ctaKey)}
              disabled={!section.available}
              onClick={section.route ? () => history.push(section.route as string) : undefined}
            />
          ))}
        </SectionGrid>
      </PageBody>
    </SideBarContainer>
  );
}
